/**
 * Frontend privilege catalog — keys must match admin-panel-backend/utils/privilegeCatalog.js
 */

export const ROLE_RANK = {
  super_admin: 0,
  admin: 1,
  super_stokez: 2,
  stokez: 3,
  agent: 4,
  player: 5,
};

export const ROLE_LABELS = {
  admin: 'Admin',
  super_stokez: 'Super Stokez',
  stokez: 'Stokez',
  agent: 'Agent',
  player: 'Player',
};

export const PRIVILEGE_CATALOG = [
  {
    group: 'Company / Brand',
    color: '#f7fafc',
    items: [
      { key: 'company.view', label: 'View Company' },
      { key: 'company.create', label: 'Create Company' },
      { key: 'company.edit', label: 'Edit Company' },
      { key: 'company.delete', label: 'Delete Company' },
    ],
  },
  {
    group: 'Game / Draw',
    color: '#ebf8ff',
    items: [
      { key: 'game.manage', label: 'Game Management' },
      { key: 'draw.manage', label: 'Draw Management' },
      { key: 'draw.current', label: 'Current Draws' },
      { key: 'draw.byGame', label: 'Draws By Game' },
      { key: 'result.control', label: 'Result Control (DS)' },
      { key: 'result.engineDebug', label: 'Draw Engine Debug' },
    ],
  },
  {
    group: 'Admin',
    color: '#faf5ff',
    items: [
      { key: 'admin.view', label: 'View Admin' },
      { key: 'admin.create', label: 'Create Admin' },
      { key: 'admin.edit', label: 'Edit Admin' },
      { key: 'admin.delete', label: 'Delete Admin' },
      { key: 'admin.lock', label: 'Lock Admin' },
      { key: 'admin.transfer', label: 'Transfer Points (Admin)' },
      { key: 'admin.balanceCheck', label: 'Toggle Balance Check' },
    ],
  },
  {
    group: 'Super Stokez',
    color: '#fff5f5',
    items: [
      { key: 'superStokez.view', label: 'View Super Stokez' },
      { key: 'superStokez.create', label: 'Create Super Stokez' },
      { key: 'superStokez.edit', label: 'Edit Super Stokez' },
      { key: 'superStokez.delete', label: 'Delete Super Stokez' },
      { key: 'superStokez.lock', label: 'Lock Super Stokez' },
      { key: 'superStokez.transfer', label: 'Transfer Points (Super Stokez)' },
    ],
  },
  {
    group: 'Stokez',
    color: '#fffaf0',
    items: [
      { key: 'stokez.view', label: 'View Stokez' },
      { key: 'stokez.create', label: 'Create Stokez' },
      { key: 'stokez.edit', label: 'Edit Stokez' },
      { key: 'stokez.delete', label: 'Delete Stokez' },
      { key: 'stokez.lock', label: 'Lock Stokez' },
      { key: 'stokez.transfer', label: 'Transfer Points (Stokez)' },
    ],
  },
  {
    group: 'Agent',
    color: '#e6fffa',
    items: [
      { key: 'agent.view', label: 'View Agent' },
      { key: 'agent.create', label: 'Create Agent' },
      { key: 'agent.edit', label: 'Edit Agent' },
      { key: 'agent.delete', label: 'Delete Agent' },
      { key: 'agent.lock', label: 'Lock Agent' },
      { key: 'agent.transfer', label: 'Transfer Points (Agent)' },
    ],
  },
  {
    group: 'Player',
    color: '#f0fff4',
    items: [
      { key: 'player.view', label: 'View Player' },
      { key: 'player.create', label: 'Create Player' },
      { key: 'player.edit', label: 'Edit Player' },
      { key: 'player.delete', label: 'Delete Player' },
      { key: 'player.lock', label: 'Lock Player' },
      { key: 'player.transfer', label: 'Transfer Points (Player)' },
      { key: 'player.approve', label: 'Approve Player Login' },
      { key: 'player.macReset', label: 'MacID Reset / Mac Check' },
      { key: 'player.setNtp', label: 'Set NTP (High/Low)' },
      { key: 'player.setTarget', label: 'Set Target %' },
      { key: 'player.setAllowedWin', label: 'Set Allowed Win / Default Allowed Win' },
      { key: 'player.setNegativeWinLimit', label: 'Set Negative Win Limit' },
      { key: 'player.giveManualWin', label: 'Give Manual Win' },
      { key: 'player.setHighLimit', label: 'Set High Limit' },
      { key: 'player.block', label: 'Block / Deactivate Player' },
    ],
  },
  {
    group: 'Reports',
    color: '#fffff0',
    items: [
      { key: 'report.summary', label: 'Summary Report' },
      { key: 'report.allTicket', label: 'All Ticket' },
      { key: 'report.superStokez', label: 'Super Stokez Wise' },
      { key: 'report.stokez', label: 'Stokez Wise' },
      { key: 'report.agent', label: 'Agent Wise' },
      { key: 'report.player', label: 'Player Wise' },
      { key: 'report.gameWise', label: 'Game Wise' },
      { key: 'report.searchBarcode', label: 'Search Barcode' },
      { key: 'report.transaction', label: 'Transaction Report' },
      { key: 'report.activityLog', label: 'Activity Log' },
      { key: 'report.auditAdmin', label: 'Audit Log: Results / Privileges / Settings / Security' },
    ],
  },
  {
    group: 'System',
    color: '#edf2f7',
    items: [
      { key: 'dashboard.view', label: 'Dashboard' },
      { key: 'settings.manage', label: 'Settings' },
      { key: 'privilege.manage', label: 'Privilege Management' },
    ],
  },
];

export const ALL_PRIVILEGE_KEYS = PRIVILEGE_CATALOG.flatMap((g) => g.items.map((i) => i.key));
